import { Component, Input, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/internal/operators/catchError'
import { map } from 'rxjs/operators';
import { FiltersService } from 'src/app/services/filtersService.service'
import { Constants } from 'src/assets/constants'

import { FundDetails } from '../../../models/fund-details.model'

const PAGE_SIZE = Constants.PAGE_SIZE

@Component({
  selector: 'VFA-results-mobile',
  templateUrl: './results.component.mobile.html',
  styleUrls: ['./results.component.scss'],
})
export class ResultsComponentMobile implements OnInit {
  public annualReturnsDate: Date
  public ytdAsOfDate: Date
  public priceAsOfDate: Date
  public page: number
  public PAGE_SIZE: number
  public activeTab: number
  filterBy = ''
  switchModel: boolean
  disableSwitch = false
  public data$: Observable<FundDetails>
  public isDataLoaded = true

  constructor(
    private readonly route: ActivatedRoute,
    private readonly filtersService: FiltersService,
  ) {}

  @Input() comparedFunds: string[] = []
  @Input() sortColumn = 'fundName'
  @Input() sortDirection = 'asc'
  @Input() viewSwitch = true;
  @Input() isNonVanguard: boolean; 
  ngOnInit(): void {
    this.PAGE_SIZE = PAGE_SIZE

    this.data$ = this.filtersService.filteredData$.pipe(
      catchError((err) => {
        console.log(err)
        this.isDataLoaded = false
        return throwError(err)
      }),
    )
    this.route.params.subscribe((params) => {
      this.disableSwitch = false
      if (params.accountingType !== undefined) {
        this.filterBy = params.accountingType
      } else {
        this.filterBy = 'all'
      }
      this.switchModel = false
      this.disableSwitch = this.filterBy !== 'etfs' && this.filterBy !== 'all'
    })
  }

  ngAfterViewInit(){
    const redemptionFeeTickers = new Set(["VGRLX", "VGRNX", "VIAAX", "VIHAX"]);
    this.data$ = this.data$.pipe(
      map(data => {
        data?.fund?.entity?.forEach(fund => {
          if (redemptionFeeTickers.has(fund.profile.ticker)) {
            fund.fees.redemptionFee.content = "0.25%"
          }
        });
        return data;
      })
    )
  }

  changeSortData(event) {
    this.sortColumn = event.sortColumn
    this.sortDirection = event.sortDirection
  }

  setPage($event) {
    this.page = $event
  }
  changeTab($event) {
    this.activeTab = $event
  }
}
